// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ytWR","messages":"Chat_messages__v9iIB","dateDivider":"Chat_dateDivider__3r2b7"};